import { Component, OnInit, AfterViewChecked, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IpsPaymentViaLinkServiceService } from '../../../../core/services/IpsPaymentViaLink.service';
import { IpsPaymentLinkModal } from '../../models/IpsPaymentLink.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PaypalPaymentDoneModal } from '../../models/PaypalPaymentDone.model';
import { PaypalLinkPaymentModal } from '../../models/PaypalLinkPayment.model';
declare let paypal: any;
declare var $: any;

@Component({
  selector: 'app-paypal-payment-via-link',
  templateUrl: './paypal-payment-via-link.component.html',
  styleUrls: ['./paypal-payment-via-link.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PaypalPaymentViaLinkComponent implements OnInit {
  linkCode: string = "";
  constructor(private _route: ActivatedRoute, private router: Router, private _service: IpsPaymentViaLinkServiceService, private _sanitizer: DomSanitizer) {}
  addScript: boolean = false;
  addScriptReoccuring: boolean = false;
  paypalLoad: boolean = true;
  finalAmount: number = 1;
  invoiceId;
  showSmallSpin: boolean;
  ipsPaymentLink: IpsPaymentLinkModal;
  transactionModal: any;
  showExpire: boolean;
  showOverlayIpsLink: boolean;
  notificationTextLink: string = "";
  notificationTextNoteLink: string = "";
  // AlertText: string;
  confirmationMessageStatus: boolean = false;
  confirmNotificationLink: boolean = false;
  saId: string = "";
  currentDate;
  currentDateOne;
  currentDateTwo;
  currentDateThree;
  description: string = "";
  url: string;
  isPaid: boolean;
  paypalPaymentId: string = "";
  masterProduct: any;
  licenseProduct: any;
  paypalPaymentDone: PaypalPaymentDoneModal;
  productAmountShow: number = 0;
  // LicenseCostShow: number = 0;
  masterCostShow: number = 0;
  productListData: any[];
  showLegalMoreId: boolean = false;
  invoiceIdOne: string = "";
  showAlert: boolean;
  // AlertAction: string;
  planId: string = "";
  reoccuringValue: boolean = true;
  trialAmount: number = 0;
  fixedAmount: number = 0;
  completeLinkData: any;
  planErrorMessage: string = "";
  subcripId: any;
  basicAuth = 'Basic AWs27Pl2N1SSyugc5AV9HN-Ustp7-rxyydDs19Zu_YH5PvsKR5JczkHnDT3MRAJEfxLW5Pwt5t44N_59EHGuOLnHxQulUY1pergZSaT7XGAsWT9YEwcDBnOCOu1bK3N3EJSz-_PqhcyW7jUfJivTcvO1ijTwClWh'; //Pass your ClientId + scret key

  ngOnInit() {
    this.planErrorMessage = "";
    this.planId = "";
    this.reoccuringValue = true;
    this.currentDateOne = new Date().getDate();
    this.currentDateTwo = new Date().getMonth() + 1;
    this.currentDateThree = new Date().getFullYear();
    this.currentDate = this.currentDateThree + "-" + this.currentDateTwo + "-" + this.currentDateOne;
    this.showOverlayIpsLink = true;
    this.paypalLoad = true;
    this.invoiceId = this.makeRandomId();
    this._route.queryParams.subscribe(params => {
      this.linkCode = params['LinkCode']
    });
    this.ipsPaymentLinkCheck(this.linkCode);
  }
  
  ipsPaymentLinkCheck(code) {
    this.ipsPaymentLink = new IpsPaymentLinkModal();
    this._service.ipsPaymentLinkCheck(code).subscribe((data: any) => {
      this.completeLinkData = data.Model;
  
      if (data.LinkExpired == true) {
        this.showExpire = true;
        this.showOverlayIpsLink = false;
      } else {
        this.invoiceIdOne = "";
        this.invoiceIdOne = data.Model.paypalDoneModal.transactions[0].invoice_number;
        this.ipsPaymentLink = data.Model;
        this.transactionModal = data.Model;
        this.saId = this.transactionModal.saId;
        this.isPaid = this.ipsPaymentLink.isPaid;
        this.paypalPaymentDone = new PaypalPaymentDoneModal();
        this.paypalPaymentDone = data.Model.paypalDoneModal;
        this.productListData = [];
        this.productListData = data.Model.buyIPSProductsModal.products;
        this.changeValueReoccur(this.reoccuringValue);
        this.showExpire = false;
        this.showOverlayIpsLink = false;
      }
    });
  }

  changeValueReoccur(reoccurValue) {
    this.planId = "";
    this.trialAmount = 0;
    this.fixedAmount = 0;
    if (reoccurValue === true) {
      this.paypalLoad = true;
      this.reoccuringValue = true;
      this.trialAmount = this.completeLinkData.trialValue;
      this.fixedAmount = this.completeLinkData.fixedValue;
      this._service.createLinkProductAndPlanForNewHa(this.completeLinkData.saHospitalName, this.completeLinkData.saName, this.trialAmount, this.fixedAmount).subscribe((data) => {
      
        this.planId = data["PlanId"] as string;
        if (this.planId != null && this.planId != undefined && this.planId != '') {
          this.onFormValidRecurring();
          document.getElementById('paypal-button-container').style.display = "block";
        } else {
          this.paypalLoad = false;
          this.planErrorMessage = "";
          this.planErrorMessage = data["Message"];
        }
      });
    }
  }

  routeBackMain() {
    this.router.navigate(['login']);
  }

  makeRandomId() {
    var date = new Date().getTime(); //Timestamp
    var dateOne = (performance && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var randomNumber = Math.random() * 16; //random number between 0 and 16
      if (date > 0) { //Use timestamp until depleted
        randomNumber = (date + randomNumber) % 16 | 0;
        date = Math.floor(date / 16);
      } else { //Use microseconds since page-load if supported
        randomNumber = (dateOne + randomNumber) % 16 | 0;
        dateOne = Math.floor(dateOne / 16);
      }
      return (character === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8)).toString(16);
    });
  }
  // AlertClose() {
  //   setTimeout(() => {
  //     this.showAlert = false;
  //   }, 5000);
  // }
  // AlertCloseips() {
  //   setTimeout(() => {
  //     this.showAlert = false;
  //     this.showSmallSpin = false;

  //     this.router.navigate(['login']);
  //   }, 3000);
  // }
  closeNotificationLink() {
    this.confirmNotificationLink = false;
    if (this.confirmationMessageStatus == true) {
      $("#notificationModallink_link").modal('hide');
      this.router.navigate(['login']);
    } else {
      $("#notificationModallink_link").modal('hide');
    }
  }

  helpVideoOpenlink(category) {
    if (category == '1') {
      this.url = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/VHPthon0YFw") as string;
      this.description = "Buy Using PayPal";
    } else {
      this.url = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/uHiR-kBszi0") as string;
      this.description = "Buy Using Credit Card";
    }
  }

  closeHelpVideolink() {
    this.url = null;
    this.description = "";
  }

  configurationValue = {
    createSubscription: (data, actions) => {
      return actions.subscription.create({
        'plan_id': this.planId,
      });
    },
    onApprove: (data) => {
      this.showSmallSpin = true;

      this.paypalPaymentId = data.subscriptionID;
      this.isPaid = true;
      let printContents;
      // var dataa: HTMLElement;
      printContents = document.getElementById('pdfdataTosend').innerHTML;
      var pdfData = "<html><head></head><body >" + printContents + "</body></html>";
      let paypalLinkPaymentModal:PaypalLinkPaymentModal = new PaypalLinkPaymentModal(this.saId,this.isPaid,this.paypalPaymentId,pdfData,this.transactionModal,this.reoccuringValue);
      this._service.paypalLinkPayment(paypalLinkPaymentModal).subscribe((data) => {
        if (data == true) {
          this.confirmationMessageStatus = true;
          this.confirmNotificationLink = true;
          this.showSmallSpin = false;
          $("#notificationModallink_link").modal('show');
          this.notificationTextLink = "Payment Successfully Done";
          this.notificationTextNoteLink = "Information of your product has been sent to registered mail address ";

        } else {
          this.confirmationMessageStatus = false;
          this.confirmNotificationLink = true;
          this.showSmallSpin = false;
          $("#notificationModallink_link").modal('show');
          this.notificationTextLink = "Payment Failed";
          this.notificationTextNoteLink = "Payement Is Failed";

        }
      });
    },
    onCancel: (data) => {
      // Show a cancel page, or return to cart  
      this.showSmallSpin = true;
      this.confirmationMessageStatus = false;
      this.confirmNotificationLink = true;
      this.showSmallSpin = false;
      $("#notificationModallink_link").modal('show');
      this.notificationTextLink = "Payment Failed";
      this.notificationTextNoteLink = "Payment Is Cancelled By User";

    },
    onError: (err) => {
      // Show an error page here, when an error occurs 
      this.showSmallSpin = true;
      this.confirmationMessageStatus = false;
      this.confirmNotificationLink = true;
      this.showSmallSpin = false;
      $("#notificationModallink_link").modal('show');
      this.notificationTextLink = "Payment Error";
      this.notificationTextNoteLink = "Error Occured .. Please Try again!!!";
    }
  };

  onFormValidRecurring() {
    // if (!this.addScript) {
    if (!this.addScriptReoccuring) {
      this.addPaypalScriptRecurring();
      paypal.Buttons(this.configurationValue).render('#paypal-button-container');
    }
    this.paypalLoad = false;
  }

  addPaypalScriptRecurring() {
    this.addScriptReoccuring = true;
  }
}
